<template>
  <div>
    <el-row style="margin: 0 auto;">
      <el-col :span="22">
        <el-form ref="searchForm" :model="searchForm" style="display: flex;column-gap: 20px;">
          <el-form-item>
            <div>
              <el-date-picker
                v-model="searchForm.date"
                type="daterange"
                size="mini"
                :clearable="false"
                class="w300"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions">
              </el-date-picker>
            </div>
          </el-form-item>
             
          <el-form-item  v-if="!userInfo.shop_id">
            <el-select
                v-model="searchForm.shop_id"
                size="mini"
                value-key="shop_id"
                placeholder="请选择"
                filterable
              >
              <el-option
                v-for="item in shopList"
                :key="item.shop_id"
                :label="item.shop_name"
                :value="item.shop_id"
              />
            </el-select>
          </el-form-item>
        </el-form>  
      </el-col>
      <el-col :span="2">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('1')">搜索</el-button>
      </el-col>
    </el-row>
    <div class="charts-container">  
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}核销业绩</div>
            <div id="main1" class="chart-content" />
          </div>
        </el-col>
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}护理人数
              <ElTooltip content="统计的是当前时间段内护理的人数（当前时间段内同一个客户护理多次只统计1次）" placement="top">
                <i class="el-icon-question" style="color: #909399; cursor: pointer"></i>
              </ElTooltip>
            </div>
            <div id="main2" class="chart-content" />
          </div>
        </el-col>
      </el-row>        
    </div>
    <div class="charts-container">  
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}护理师消耗额与贡献度分析</div>
            <div id="main3" class="chart-content" />
          </div>
        </el-col>
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}护理师收款本金与赠金分析</div>
            <div id="main4" class="chart-content" />
          </div>
        </el-col>
      </el-row>        
    </div>
    <div class="charts-container">  
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}护理师新单补单业绩</div>
            <div id="main5" class="chart-content" />
          </div>
        </el-col>
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}护理师护理人数
                <ElTooltip content="统计的是当前时间段内护理的人数（当前时间段内同一个客户护理多次只统计1次）" placement="top">
                  <i class="el-icon-question" style="color: #fff; cursor: pointer"></i>
                </ElTooltip>
              /护理量/护理金额分析</div>
            <div id="main6" class="chart-content" />
          </div>
        </el-col>
      </el-row>        
    </div>
    <div class="charts-container">  
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}服务核销数据</div>
            <div id="main7" class="chart-content" />          
          </div>
        </el-col>
      </el-row>        
    </div>
    <div class="charts-container">  
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}产品出库明细</div>
            <div id="main8" class="chart-content" />          
          </div>
        </el-col>
      </el-row>        
    </div>
    <div class="charts-container">
      <el-row :gutter="20">
        <el-col :span="12" class="table-container">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom:3%;">{{name}}服务消耗表</div>
            <el-table
              :data="realServiceList"
              height="600"
              size="small"
              :default-sort = "{prop:'consume_count', order: 'descending'}"
              :row-class-name="tableRowClassName"
              >
              <el-table-column prop="name" label="服务名称" width="220"/>
              <el-table-column prop="consume_bj" label="核销金额（本金）" align="center"  sortable />
              <el-table-column prop="consume_count" label="核销数量" align="center" sortable />
              
              <ElTableColumn label="护理人数" prop="serve_num" align="center"  sortable>
                <template #header>
                  <div style="display: flex; align-items: center; ">
                    护理人数
                    <ElTooltip content="统计的是当前时间段内护理的人数（当前时间段内同一个客户护理多次只统计1次）" placement="top">
                      <i class="el-icon-question" style="color: #fff; cursor: pointer"></i>
                    </ElTooltip>
                  </div>
                </template>
              </ElTableColumn>

              
              <el-table-column prop="once_serve_amount" label="单次护理金额"  width="140" align="center" sortable/>
            </el-table>
          </div>
        </el-col>
        <el-col :span="12" class="table-container">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 3%;">{{name}}产品出库表</div>
            <el-table
              :data="realGoodsList"
              height="600"
              size="small"
              :row-class-name="tableRowClassName"
              :default-sort = "{prop: 'pay_amount', order: 'descending'}">
              <el-table-column prop="name" label="产品名称" width="220"/>
              <el-table-column prop="pay_amount" label="核销金额（本金）" align="center"  sortable />
              <el-table-column prop="num" label="核销数量" align="center" sortable />
              <el-table-column prop="cj_num" label="人数" align="center" sortable />
              <el-table-column prop="once_amount" label="单件金额"  width="140" align="center" sortable/>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="charts-container">
      <el-row>
        <el-col :span="24" class="table-container">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}护理师业绩表</div>
            <el-table
              :data="tableData"
              border
              size="small"
              :default-sort = "{prop: 'receipts', order: 'descending'}"
              :cell-style="$style.cellStyle"
              :row-class-name="tableRowClassName"
              :header-cell-style="$style.rowClass"
              >
              <el-table-column prop="name" label="护理师" width="120"/>
              <el-table-column prop="receipts" label="实收款金额" sortable />
              <el-table-column prop="receipts_gift" label="收款赠金" sortable />
              <el-table-column prop="contribution_rete" label="护理师贡献度" sortable>
                <template slot-scope="{row}"> 
                  {{row.contribution_rete}}%
                </template>    
              </el-table-column>             
              <el-table-column prop="xd_perform" label="新单业绩"  sortable/>
              <el-table-column prop="bd_perform" label="补单业绩"  sortable/>
              <el-table-column prop="consume_amount" label="品项消耗金额" sortable/>
              <el-table-column prop="goods_consume_amount" label="商品出库金额" sortable/>
              <el-table-column prop="transfer_amount" label="转诊消耗金额" sortable/>
              <el-table-column prop="abnormal_consume_amount" label="异常消耗" sortable/>
              <el-table-column prop="consume_sum_amount" label="消耗总额" sortable/>
              <ElTableColumn label="护理人数" prop="amount_care_num" align="center"  sortable>
                <template #header>
                  <div style="display: flex; align-items: center; ">
                    护理人数
                    <ElTooltip content="统计的是当前时间段内护理的人数（当前时间段内同一个客户护理多次只统计1次）" placement="top">
                      <i class="el-icon-question" style="color: #fff; cursor: pointer"></i>
                    </ElTooltip>
                  </div>
                </template>
              </ElTableColumn>
              <el-table-column prop="num_care" label="护理量" sortable/>
              <el-table-column prop="consume_avg" label="单次护理金额（本金）" width="200" sortable/>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>
    
    
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { getPersonChannel,getLookShop ,serviceTop,staffGoodsTop,realServiceTop,realGoodsTop} from '@/api/sys'
import { mapGetters } from "vuex";

class Search {
  date = [];                  
  shop_id = '';
}

export default {
  props: {
    tabIndex: {
      type: Number,
      default: 0
    },
  },
    watch: {
    // 监听 tabIndex 变化，触发刷新
    tabIndex(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getList(); // 调用数据加载方法
      }
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),
    // tableData() {
    //   const res = this.list.reduce((res, item) => {
    //     item.maxnum = 0;
    //     if (item.list && item.list.length > 0) {
    //       const goods = item.list.map(goods => Object.assign({}, item, goods));
    //       goods[0].maxnum = item.list.length;
    //       res = res.concat(goods);
    //     } else {
    //       res.push(item);
    //     }
    //     return res;
    //   }, []);
    //   return res;
    // },
  },
  data() {
    const that = this; 
    return {  
    pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          if (minDate) {
            that.searchForm.date[0] = minDate.getTime(); 
          }
          if (maxDate) {
            that.searchForm.date[1] = maxDate.getTime(); 
          }
        },
        disabledDate: (time) => {
          console.log(time,"time")
          const year = time.getFullYear();
          if (year <= 2024) {
            return true;
          }
          const currentTime = time.getTime();
          const now = Date.now(); 
          console.log(that.searchForm.date[0],"that.searchForm.date[0]")
          if (that.searchForm.date[0]) {
            const startDate = new Date(that.searchForm.date[0]);
            const twoMonthsLater = new Date(startDate);
            twoMonthsLater.setMonth(twoMonthsLater.getMonth() + 2);
            const twoMonthsEarlier = new Date(startDate);
            twoMonthsEarlier.setMonth(twoMonthsEarlier.getMonth() - 2);
            return currentTime < twoMonthsEarlier || currentTime > twoMonthsLater || currentTime > now;
          }
        }
      },
      searchForm: new Search(),
      list:[],
      tableData:[],
      shopList:[],
      realServiceList:[],
      realGoodsList:[],
      hlNum:0,
      name:'',
      skAmount:0,
      chart1: null,
      chart2: null,
      chart3: null,
      chart4: null,
      chart5: null,
      chart6: null,
      chart7: null,
    }
  },
  
  mounted() {
    this.$nextTick(() => {
      this.initCharts();
      this.getList();
      window.addEventListener('resize', this.handleResize);
    });
  },
  
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('resize', this.handleResize);
    if (this.chart1) this.chart1.dispose();
    if (this.chart2) this.chart2.dispose();
    if (this.chart3) this.chart3.dispose();
    if (this.chart4) this.chart4.dispose();
    if (this.chart5) this.chart5.dispose();
    if (this.chart6) this.chart6.dispose();
    if (this.chart7) this.chart7.dispose();
  },
  
  methods: {
    // generateDefaultThreeMonths() {
    //   const now = new Date();
    //   const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
    //   const monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    //   const format = (date) => {
    //     return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
    //   };
    //   return [format(monthStart), format(monthEnd)];
    // },
 
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return {
          rowspan: row.maxnum,
          colspan: 1
        };
      } else {
        return {
          rowspan: 1,
          colspan: 1
        };
      }
    },
    // 初始化图表实例
    initCharts() {
      const main1Dom = document.getElementById('main1');
      const main2Dom = document.getElementById('main2');
      const main3Dom = document.getElementById('main3');
      const main4Dom = document.getElementById('main4');
      const main5Dom = document.getElementById('main5');
      const main6Dom = document.getElementById('main6');
      const main7Dom = document.getElementById('main7');
      const main8Dom = document.getElementById('main8');



      
      // 确保容器存在再初始化
      if (main1Dom) this.chart1 = echarts.init(main1Dom);
      if (main2Dom) this.chart2 = echarts.init(main2Dom);
      if (main3Dom) this.chart3 = echarts.init(main3Dom);
      if (main4Dom) this.chart4 = echarts.init(main4Dom);
      if (main5Dom) this.chart5 = echarts.init(main5Dom);
      if (main6Dom) this.chart6 = echarts.init(main6Dom);
      if (main7Dom) this.chart7 = echarts.init(main7Dom);
      if (main8Dom) this.chart8 = echarts.init(main8Dom);



    },
    
    // 统一处理resize
    handleResize() {
      if (this.chart1) this.chart1.resize();
      if (this.chart2) this.chart2.resize();
      if (this.chart3) this.chart3.resize();
      if (this.chart4) this.chart4.resize();
      if (this.chart5) this.chart5.resize();
      if (this.chart6) this.chart6.resize();
      if (this.chart7) this.chart7.resize();
      if (this.chart8) this.chart8.resize();


    },
    
    async getList() {
      const loading = this.$loading({
        lock: true,
        text: "加载中，请稍后...",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)"
      });

      try {
        const shopRes = await getLookShop();
        this.shopList = shopRes.data || []; // 空值兜底，避免后续数组操作报错

        if (this.userInfo?.shop_id) { 
          this.searchForm.shop_id = this.userInfo.shop_id;
        } else if( this.searchForm.shop_id == ''){
            this.searchForm.shop_id = this.shopList.length > 0 
            ? this.shopList[0].shop_id || ''  
            : '';  
        } else {
          this.searchForm.shop_id = this.searchForm.shop_id ;
        }

        const commonParams = {
          start_time: this.searchForm.date[0] || '',
          end_time: this.searchForm.date[1] || '',
          shop_id: this.searchForm.shop_id
        };

        const [goodsRes,realServiceRes,channelRes] = await Promise.all([
          staffGoodsTop(commonParams),
          realServiceTop(commonParams),
          getPersonChannel(commonParams),
        ]);

        this.realGoodsList = goodsRes.data || [];
        this.echartsRealGoods(this.realGoodsList);
        this.realServiceList = realServiceRes.data[0].list || [];
        this.echartsRealService(this.realServiceList.slice(0, -1));
        this.list = channelRes.data || [];
        const firstShop = this.list[0] || {};
        this.tableData = firstShop.list || []; 
        this.name = firstShop.shop_name || '未知店铺'; 

        if (this.tableData.length > 0) {
          const lastItem = this.tableData[this.tableData.length - 1];
          this.skAmount = Number(lastItem.consume_sum_amount) || 0;
          this.hlNum = Number(lastItem.amount_care_num) || 0; 
          this.echarts1(this.tableData.slice(0, -1));
        } else {
          this.skAmount = '0.00';
          this.hlNum = 0;
          this.echarts1([]); // 图表传空数组
        }

      } catch (err) {
        console.error("接口请求出错：", err);
        this.$message.error("数据加载失败，请重试");
      } finally {
        loading.close();
        this.$nextTick(() => {
          this.handleResize();
        });
      }
    },
    echartsRealGoods(jine){
      if (!this.chart8) return;
      const sortedJine = [...jine].sort((a, b) => {
        return Number(b.pay_amount) - Number(a.pay_amount);
      });
       
      const option8 = {
        tooltip: {
          trigger: 'axis',
          textStyle: { align: 'left' },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('数量') ? '个' : 
                          item.seriesName.includes('核销额') ? '元' : '人';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          right: 'center',
          top: '0%',
          data: ['核销额', '数量', '人数'], // 图例顺序（与系列name匹配即可）
          selected: {
            '核销额': true,    // 默认隐藏
            '数量': false, // 默认隐藏
            '人数': false        // 默认显示
          },
          selectedMode: 'single', // 核心配置：开启图例单选模式（每次仅一个选中）
          textStyle: {}
        },
         dataZoom: [
          {
            type: 'slider', // 滑动条型数据区域缩放
            show: true,     // 显示滑动条
            xAxisIndex: 0,  // 作用于第一个x轴
            start: 0,       // 初始显示范围的起始百分比
            end: 50,        // 初始显示范围的结束百分比（根据数据量调整）
            bottom: 0       // 滑动条位置
          }
        ],
        grid: {
          left: '3%',
          right: '3%',
          bottom: '1%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: sortedJine.map(item => item.name),
          axisLine: { lineStyle: {} },
          axisLabel: { rotate: 45, interval: 0, color: '#000', fontSize: 12 }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量',
            nameTextStyle: { color: '#666', fontSize: 12, padding: [0, 0, 0, 5] },
            axisLine: { lineStyle: { color: '#3468E9' } },
            axisLabel: { formatter: '{value}', color: '#666', fontSize: 12 },
            splitLine: { lineStyle: { color: '#CDD3E2' } }
          },
          {
            type: 'value',
            name: '金额（元）',
            nameTextStyle: { color: '#666', fontSize: 12, padding: [0, 5, 0, 0] },
            axisLine: { show: false },
            axisLabel: { formatter: '{value}元', color: '#666', fontSize: 12 },
            splitLine: { lineStyle: { color: '#CDD3E2' }}
          }
        ],
        series: [
          {
            name: '核销额', // 与legend.data[0]匹配
            type: 'bar',
            data: sortedJine.map(item => item.pay_amount),
            barWidth: '40%', // 单选模式下仅显示一列，加宽柱子更美观（原20%→40%）
            yAxisIndex: 1,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#B6C2DC' },
                { offset: 1, color: '#4C5F8D' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: params => params.value === 0 ? '' : params.value + '元'
            }
          },
          {
            name: '数量', // 与legend.data[1]匹配
            type: 'bar',
            data: sortedJine.map(item => item.num),
            barWidth: '40%',
            yAxisIndex: 0,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#79A7FE' },
                { offset: 1, color: '#3468E9' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: params => params.value === 0 ? '' : params.value + '个'
            }
          },
          {
            name: '人数', // 与legend.data[2]匹配
            type: 'bar',
            data: sortedJine.map(item => item.cj_num),
            barWidth: '40%',
            yAxisIndex: 0,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' },
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: params => params.value === 0 ? '' : params.value + '人'
            }
          }
        ]
      };
      this.chart8.setOption(option8);
    },
    echartsRealService(jine){
      if (!this.chart7) return;
      const sortedJine = [...jine].sort((a, b) => {
        return Number(b.consume_count) - Number(a.consume_count);
      });
      const option7 = {
        title: {
          show: false,
          text: `${this.name}/护理人数/护理量/护理金额分析`,
          left: 'center',
          textStyle: { fontSize: 24 }
        },
        tooltip: {
          trigger: 'axis',
          textStyle: { align: 'left' },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('护理量') ? '次' : 
                          item.seriesName.includes('金额') ? '元' : '人';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          right: 'center',
          top: '0%',
          data: ['核销数', '护理人数', '单次核销金额'], // 图例顺序（与系列name匹配即可）
          selected: {
            '护理人数': false,    // 默认隐藏
            '单次核销金额': false, // 默认隐藏
            '核销数': true        // 默认显示
          },
          selectedMode: 'single', // 核心配置：开启图例单选模式（每次仅一个选中）
          textStyle: {}
        },
        
         dataZoom: [
          {
            type: 'slider', // 滑动条型数据区域缩放
            show: true,     // 显示滑动条
            xAxisIndex: 0,  // 作用于第一个x轴
            start: 0,       // 初始显示范围的起始百分比
            end: 50,        // 初始显示范围的结束百分比（根据数据量调整）
            bottom: 0       // 滑动条位置
          }
        ],
        grid: {
          left: '3%',
          right: '3%',
          bottom: '1%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: sortedJine.map(item => item.name),
          axisLine: { lineStyle: {} },
          axisLabel: { rotate: 45, interval: 0, color: '#000', fontSize: 12 }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量',
            nameTextStyle: { color: '#666', fontSize: 12, padding: [0, 0, 0, 5] },
            axisLine: { lineStyle: { color: '#3468E9' } },
            axisLabel: { formatter: '{value}', color: '#666', fontSize: 12 },
            splitLine: { lineStyle: { color: '#CDD3E2' } }
          },
          {
            type: 'value',
            name: '金额（元）',
            nameTextStyle: { color: '#666', fontSize: 12, padding: [0, 5, 0, 0] },
            axisLine: { show: false },
            axisLabel: { formatter: '{value}元', color: '#666', fontSize: 12 },
            splitLine: { lineStyle: { color: '#CDD3E2' }}
          }
        ],
        series: [
          {
            name: '核销数', // 与legend.data[0]匹配
            type: 'bar',
            data: sortedJine.map(item => item.consume_count),
            barWidth: '40%', // 单选模式下仅显示一列，加宽柱子更美观（原20%→40%）
            yAxisIndex: 0,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#B6C2DC' },
                { offset: 1, color: '#4C5F8D' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: params => params.value === 0 ? '' : params.value + '次'
            }
          },
          {
            name: '护理人数', // 与legend.data[1]匹配
            type: 'bar',
            data: sortedJine.map(item => item.serve_num),
            barWidth: '40%',
            yAxisIndex: 0,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#79A7FE' },
                { offset: 1, color: '#3468E9' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: params => params.value === 0 ? '' : params.value + '人'
            }
          },     
          {
            name: '单次核销金额', // 与legend.data[2]匹配
            type: 'bar',
            data: sortedJine.map(item => item.once_serve_amount),
            barWidth: '40%',
            yAxisIndex: 1,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' },
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: params => params.value === 0 ? '' : params.value + '元'
            }
          }
        ]
      };
      this.chart7.setOption(option7);
    },
    echarts1(jine) {
      if (!this.chart1) return;
      if (!this.chart2) return;
      if (!this.chart3) return;
      if (!this.chart4) return;
      if (!this.chart5) return;
      if (!this.chart6) return;

      const professionalColors1 = ['#6A98E4', '#2767FC', '#85D4EE', '#EB5B73','#FFA06C','#376473','#31c5e9'];
      const professionalColors2 = ['#9FE6B8', '#32C5E9', '#2767FC', '#9D96F5','#E062AE','#FFA06C','#FEDB65'];

      const option1 = {
        // color: professionalColors1,
        title: {
         text: this.skAmount,
          textStyle: {
            fontSize: 32, 
            color: '#2767FC ', 
            fontWeight: 'bold'
          },
          left: 'center',
          top: 'center', 
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c}元 ({d}%)'
        },
        legend: {
          show: false
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '65%'],
            labelLine: {
              length: 30
            },
            label: {
              formatter: '{b}: {c}元 \n({d}%)',
              fontWeight: 'bold',
              fontSize: 14,
              backgroundColor: 'rgba(255, 255, 255, 1)', 
              padding: [8, 10], 
              borderRadius: 4, 
              borderWidth: 1 
            },
            data: jine.map(item => ({
              name: item.name, // 渠道名称（与图例对应）
              value: item.consume_sum_amount // 成交金额（用于计算占比）
            })),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }                 
          } 
        ]
      };
      const option2 = {
        color: professionalColors2,
        title: {
         text: this.hlNum,
          textStyle: {
            fontSize: 32,
            color: '#2767FC ',
            fontWeight: 'bold'
          },
          left: 'center',
          top: 'center', 
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c}人 ({d}%)' // 保持人数单位，正确
        },
        legend: {
          show: false

        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '65%'], // 内半径40%（控制中心区域大小）
            labelLine: {
              length: 30
            },
            label: {
              formatter: '{b}: {c}人 \n({d}%)',
              
              fontWeight: 'bold',
              fontSize: 14,
              backgroundColor: 'rgba(255, 255, 255, 1)',
              padding: [8, 10],
              borderRadius: 4,
              borderWidth: 1
            },
            data: jine.map(item => ({
              name: item.name,
              value: item.amount_care_num // 确保item.amount是人数数据
            })),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ],
      };
      const option3 = {
        title: {
          show:false,
          text: `${this.name}护理师销售额与消耗额分析`,
          left: 'center',
          textStyle: { 
            fontSize: 24
          }
        },
        tooltip: {
          trigger: 'axis',       
          textStyle: {
            align: 'left'  // 核心属性：强制内容左侧对齐（默认是 'center' 或自适应）
          },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('护理师贡献度') ? '%' : '元';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          left: 'center',
          top: '0%',
          data: [ '销售额','消耗额'],
          textStyle: {}
        },
        grid: {
          left: '5%',
          right: '5%', // 为右侧Y轴腾出更多空间
          bottom: '1%', // 增加底部空间防止标签截断
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: jine.map(item => item.name),
          axisLine: { lineStyle: {} },
          axisLabel: { rotate: 45, interval: 0,color: '#000',fontSize: 12 }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量（元）',
            nameTextStyle: {},
            axisLine: { lineStyle: {  } },
            axisLabel: {  formatter: '{value}元' },
            splitLine: { lineStyle: { color: '#CDD3E2' } }
          }
        ],
        series: [
          {
            name:'销售额',
            type: 'bar',
            data: jine.map(item => item.receipts),
            barWidth: '20%',
            barCategoryGap: '30%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: '#3468E9' },
                { offset: 0, color: '#79A7FE' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              // formatter: '{c}%' // 显示百分比符号
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }
            }
          },
          {
            name: '消耗额',
            type: 'bar',
            data: jine.map(item => item.consume_amount),
            symbol: 'circle', // 添加标记点
            symbolSize: 8,
            lineStyle: {
              color: '#78DF69',
              width: 2
            },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' }, // 橙色系区分
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              // formatter: '{c}元' // 显示百分比符号       
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }

            }
          }
        ]
      };

      const option4 ={
        title: {
          show:false,
          text: `${this.name}护理师收款本金与赠金分析`,
          left: 'center',
          textStyle: { 
            fontSize: 24
          }
        },
        tooltip: {
          trigger: 'axis',       
          textStyle: {
            align: 'left'  // 核心属性：强制内容左侧对齐（默认是 'center' 或自适应）
          },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('赠送比例') ? '%' : '元';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          left: 'center',
          top: '0%',
          data: [ '收款本金','收款赠金','赠送比例'],
          textStyle: {}
        },
        grid: {
          left: '5%',
          right: '5%', // 为右侧Y轴腾出更多空间
          bottom: '1%', // 增加底部空间防止标签截断
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: jine.map(item => item.name),
          axisLine: { lineStyle: {} },
          axisLabel: { rotate: 45, interval: 0,color: '#000',fontSize: 12 }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量（元）',
            nameTextStyle: {
              color: '#666',
              fontSize: 12,
              padding: [0, 0, 0, 5]
            },
            axisLine: { 
              lineStyle: { 
                color: 'red' 
              } 
            },
            axisLabel: {  
              formatter: '{value}元',
              color: '#666',
              fontSize: 12
            },
            splitLine: { 
              lineStyle: { 
                color: '#CDD3E2' 
              } 
            }
          },
          {
            type: 'value',
            name: '比例',
            nameTextStyle: {
              color: '#666',
              fontSize: 12,
              padding: [0, 5, 0, 0]
            },
            axisLine: { 
              show: true, // 显示第二条Y轴线以便观察
              lineStyle: {
                color: 'none' // 与贡献度颜色呼应
              }
            },
            axisLabel: {  
              formatter: '{value}%',
              color: '#666',
              fontSize: 12
            },
            splitLine: { 
              show: false 
            },
          }
        ],
        series: [
          {
            name: '收款本金',
            type: 'bar',
            yAxisIndex: 0, // 关键修复：指定使用第二个Y轴
            data: jine.map(item => item.receipts),
            barWidth: '20%',
            barCategoryGap: '30%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: '#3468E9' },
                { offset: 0, color: '#79A7FE' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              // formatter: '{c}元' 
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }
            }
          },
          {
            name: '收款赠金',
            type: 'bar',
            yAxisIndex: 0, 
            data: jine.map(item => item.receipts_gift),
            barWidth: '20%',
            barCategoryGap: '30%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' }, // 橙色系区分
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              // formatter: '{c}元' // 显示百分比符号
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }
            }
          },
          {
            name: '赠送比例',
            type: 'line',
            yAxisIndex: 1, 
            data: jine.map(item => {
              const gift = Number(item.receipts_gift) || 0; // 转换为数值，默认0
              const total = Number(item.receipts) || 0;
              return total === 0 ? 0 : Number(((gift / total) * 100).toFixed(2));
            }),
            symbol: 'circle', // 添加标记点
            symbolSize: 8,
            lineStyle: {
              color: '#78DF69',
              width: 2
            },
            itemStyle: {
              color: '#78DF69',
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              // formatter: '{c}%' // 显示百分比符号
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '%';
              }
            }
          }
        ]
      };
      const option5 = {
        title: {
          show:false,
          text: `${this.name}护理师新单补单业绩`,
          left: 'center',
          textStyle: { 
            fontSize: 24

          }
        },
        tooltip: {
          trigger: 'axis',       
          textStyle: {
            align: 'left'  // 核心属性：强制内容左侧对齐（默认是 'center' 或自适应）
          },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('转化率') ? '%' : '元';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          right: 'center', // 缩小右侧间距，避免遮挡
          top: '0%',
          data: ['新单业绩', '补单业绩'],
          textStyle: {  }
        },
        grid: {
          left: '5%',
          right: '5%', // 为图例腾出空间
          bottom: '1%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: jine.map(item => item.name),
          axisLine: { lineStyle: { } },
          axisLabel: { rotate: 45, interval: 0,color: '#000',fontSize: 12 }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量（元）',
            nameTextStyle: {},
            axisLine: { lineStyle: {  } },
            axisLabel: {  formatter: '{value}元' },
            splitLine: { lineStyle: { color: '#CDD3E2' } }
          }
        ],
        series: [
          {
            name: '新单业绩',
            type: 'bar',
            data: jine.map(item => item.xd_perform),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#79A7FE' },
                { offset: 1, color: '#3468E9' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top', // 水平条形图的“上边”对应右侧
              fontSize: 14,
              // formatter: '{c}元' // 显示百分比符号
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }

            }
          },
          {
            name: '补单业绩',
            type: 'bar',
            data: jine.map(item => item.bd_perform),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' }, // 橙色系区分
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top', // 水平条形图的“上边”对应右侧
              fontSize: 14,
              // formatter: '{c}元' // 显示百分比符号
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }

            }
          }
        ]
      };
      const option6 = {
        title: {
          show:false,
          text: `${this.name}护理师护理量/人头数/护理金额分析`,
          left: 'center',
          textStyle: {
            fontSize: 24
          }
        },
        tooltip: {
          trigger: 'axis',       
          textStyle: {
            align: 'left'  // 核心属性：强制内容左侧对齐（默认是 'center' 或自适应）
          },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('护理量') ? '次' : 
                          item.seriesName.includes('金额') ? '元' : '人';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          right: 'center',
          top: '0%',
          data: ['护理人数', '护理量', '单次护理金额（本金）'],
          textStyle: {}
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '1%', // 增加底部空间，避免滑动条遮挡
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: jine.map(item => item.name),
          axisLine: { lineStyle: {} },
          axisLabel: { 
           rotate: 45, interval: 0,color: '#000',fontSize: 12
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量',
            nameTextStyle: {
              color: '#666',
              fontSize: 12,
              padding: [0, 0, 0, 5]
            },
            axisLine: { 
              lineStyle: { 
                color: '#3468E9'
              } 
            },
            axisLabel: {  
              formatter: '{value}',
              color: '#666',
              fontSize: 12
            },
            splitLine: { 
              lineStyle: { 
                color: '#CDD3E2' 
              } 
            }
          },
          {
            type: 'value',
            name: '金额（元）',
            nameTextStyle: {
              color: '#666',
              fontSize: 12,
              padding: [0, 5, 0, 0]
            },
            axisLine: { 
              show: false
            },
            axisLabel: {  
              formatter: '{value}元',
              color: '#666',
              fontSize: 12
            },
            splitLine: { 
              show: false 
            }
          }
        ],
        series: [
          {
            name: '护理人数',
            type: 'bar',
            data: jine.map(item => item.amount_care_num),
            barWidth: '20%',
            yAxisIndex: 0,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#79A7FE' },
                { offset: 1, color: '#3468E9' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              // formatter: '{c}人'
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '人';
              }
            }
          },
          {
            name: '护理量',
            type: 'bar',
            data: jine.map(item => item.num_care),
            barWidth: '20%',
            yAxisIndex: 0,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#B6C2DC' },
                { offset: 1, color: '#4C5F8D' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              // formatter: '{c}次'
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '次';
              }
            }
          },
          {
            name: '单次护理金额（本金）',
            type: 'bar',
            data: jine.map(item => item.consume_avg),
            barWidth: '20%',
            yAxisIndex: 1,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' },
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              // formatter: '{c}元'
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }
            }
          }
        ]
      };

      this.chart1.setOption(option1);
      this.chart2.setOption(option2);
      this.chart3.setOption(option3);
      this.chart4.setOption(option4);
      this.chart5.setOption(option5);
      this.chart6.setOption(option6);


    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex%2 == 0) {
        return 'ou-row';

      } else{
        return 'ji-row';

      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-table tr.ou-row {
  background-color: #EEF6FF;
}
::v-deep .el-table tr.ji-row {
  background-color: #D4E6F4;
}

 ::v-deep .el-table__cell {
  //  background: #EEF6FF !important;
   color: #2861C0 !important;
   color: #333333 !important;
   color: #2861C0 !important;

   font-weight: 600;
   font-size: 15px;
 }
  // ::v-deep .el-table__body {
  //   td:nth-child(1) { // 第2列
  //     color: #000000 !important;
  //   }
  // }

::v-deep .el-table__header .el-table__cell {
  background: #C2DBF9  !important; /* 与内容区背景统一 */
  color: #000000 !important;
}

::v-deep .el-table__row:hover > .el-table__cell {
  // background: #C2DBF9  !important; /* 略浅的hover背景，保持一致性 */
}
.flex{
  color: #333;
  width: 95%;
  margin: 0 auto;
  margin-bottom: 4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  div{
    font-size: 1.2rem;
    padding: 1.5rem 3rem;
    border: 1px solid #EDF2FF;
    border-radius: 0.5rem;
    box-shadow: inset 0 0 0.5rem #EDF2FF;
    background-color: #EDF2FF;
    overflow: hidden;
    text-align: center;
    span{
      display: block; 
      font-size: 2.5rem;
      line-height: 3rem;
      margin-bottom: 0.3rem;
    }
  }
}
/* 图表容器样式优化 */
.charts-container {
  margin: 20px 0;
 text-align: center;

   .table-title{
    display: inline-block; 
    font-size: 1.5rem;
    font-weight: 600;
    color: #fff;
    background: #79A7FE;
    // background: #C2DBF9;
  //  background: linear-gradient(270deg, #33bea7 0%, #60e0c5 50%, #88f0e1 100%);
    padding:1rem ;
    border-radius: 1rem;

  }
}

.chart-wrapper {
  width: 100%;
  box-sizing: border-box; /* 确保padding不会增加元素总宽度 */
  background: #EDF2FF;
  padding: 2%;
  box-sizing: border-box;
  border-radius: 3rem;
}

.chart-content {
  width: 100%;
  height: 500px; /* 固定高度，确保初始化时有明确尺寸 */
}
</style>
